<template>
 <ubi-page-container class="tutorals-videos TutoralsVideos" wide-main-content>
   <template v-slot:page-actions>
     <el-button type="primary" class="button-pdf" @click="redirectNoteUtilisation">{{ $t("tutoralsVideos.textButtonGuide")}}</el-button>
   </template>
   <template v-slot:page-tabs>
     <el-tabs v-model="currentTheme" class="TutoralsVideos-tabs">
       <el-tab-pane
           v-for="tab in themeTabs"
           :key="tab.id"
           :label="tab.label"
           :name="tab.id"
       />
     </el-tabs>
   </template>
   <el-main>
     <ubi-panel>
       <section class="cards-container">
         <card-video
             v-for="video in visibleVideos"
             :key="video.id"
             :sectionId="video.sectionId"
             :category="video.category"
             :link="video.linkVideo"
             :description="video.description"
             :title="video.title"
             :newReleaseEndDate="video.newReleaseEndDate"
             :counterVideos="countersVideos(video.sectionId)"
         />
       </section>
     </ubi-panel>
   </el-main>
 </ubi-page-container>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'
import CardVideo from '@/components/CardVideo'
import UbiPageContainer from '@/components/PageContainer'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'TutoralsVideos',
  props: ['widthDesktop'],
  components: {
    UbiPageContainer,
    UbiPanel,
    CardVideo,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data () {
    return {
      link: null,
      tutoralsVideos: [],
      counters: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      currentTheme: '1'
    }
  },
  methods: {
    eventAnalytics (category) {
      if (this.isPromoteur) {
        this.filter.annonceParente = null
      }
      this.$ga.event('navigation_permanente', 'clic', category, this.sitimmoUser.id)
    },
    redirectNoteUtilisation () {
      this.eventAnalytics('aide')
      window.open(this.link)
    },
    countersVideos (sectionId) {
      return sectionId !== undefined ? this.counters[Math.floor(sectionId)] : 0
    },
    ensureCurrentTheme () {
      const tabs = this.themeTabs
      if (!tabs.length) {
        return
      }
      const requestedTheme = String(this.$route.query.theme || '')
      const hasRequestedTheme = tabs.some(tab => tab.id === requestedTheme)
      this.currentTheme = hasRequestedTheme ? requestedTheme : tabs[0].id
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isUSH () {
      return this.$store.getters.getUser.isUSH
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    themeTabs () {
      const tabs = [
        { id: '1', label: this.$t('tutoralsVideos.menu.linkDashboard').trim() },
        {
          id: '2',
          label: this.$t(
            this.isPromoteur ? 'tutoralsVideos.menu.linkProgramsPage' : 'tutoralsVideos.menu.linkAnnouncementsPage'
          ).trim()
        },
        { id: '3', label: this.$t('tutoralsVideos.menu.linkBroadcast').trim() },
        { id: '4', label: this.$t('tutoralsVideos.menu.linkContactManager').trim() },
        { id: '5', label: this.$t('tutoralsVideos.menu.linkSocialManagement').trim() }
      ]
      return tabs.filter(tab => this.counters[tab.id] > 0)
    },
    visibleVideos () {
      return this.tutoralsVideos.filter(video =>
        video.metiers.includes(this.sitimmoUser.metier) &&
        String(video.sectionId) === this.currentTheme
      )
    }
  },
  watch: {
    currentTheme (theme) {
      if (this.$route.query.theme !== theme) {
        this.$router.replace({ path: this.$route.path, query: { theme } })
      }
    },
    '$route.query.theme': {
      immediate: true,
      handler () {
        this.ensureCurrentTheme()
      }
    }
  },
  beforeMount () {
    switch (this.sitimmoUser.metier) {
      case 'CMI': this.link = '/docs/Espace client Ubiflow - note d_utilisation (CMI).pdf'
        break
      case 'PROMOTEUR': this.link = '/docs/Espace client Ubiflow - note d_utilisation (promotion).pdf'
        break
      case 'BAILLEUR_SOCIAL && !isUSH ': this.link = '/docs/Espace client Ubiflow - note d_utilisation (bailleurs sociaux).pdf'
        break
      case 'BAILLEUR_SOCIAL && isUSH ': this.link = '/docs/Espace client Ubiflow - note d_utilisation (bailleurs sociaux USH).pdf'
        break
      case 'CONCESSIONNAIRE' : this.link = '/docs/Espace client Ubiflow - note d_utilisation (VO).pdf'
        break
      case 'SPECIALISTE_VO' : this.link = '/docs/Espace client Ubiflow - note d_utilisation (VO).pdf'
        break
      default:
        this.link = '/docs/Espace client Ubiflow - note d_utilisation (immo ancien).pdf'
    }
    this.tutoralsVideos = this.$store.getters.getTutoralsVideos
    this.tutoralsVideos.forEach(video => {
      if (video.sectionId && video.metiers.includes(this.sitimmoUser.metier)) {
        this.counters[Math.floor(video.sectionId)] += 1
      }
    })
    this.ensureCurrentTheme()
  }
}
</script>
<style lang="scss">
@import "@/theme/_bootstrap.scss";

.TutoralsVideos {
  &-tabs {
    .el-tabs__header {
      margin: 0;
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__item {
      outline: none !important;

      &:focus {
        outline: none !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/theme/_bootstrap.scss";
.button-pdf{
  border-radius: 5px;
  outline: none;
}
.cards-container{
  display: flex;
  flex-wrap: wrap;
}
</style>
